import { create } from 'zustand';

interface DocumentState {
  activeDocumentPath: string | null;
  activeHeadingId: string | null;
  
  setActiveDocument: (path: string | null) => void;
  setActiveHeading: (headingId: string | null) => void;
}

export const useDocumentStore = create<DocumentState>((set) => ({
  activeDocumentPath: null,
  activeHeadingId: null,

  setActiveDocument: (activeDocumentPath) => set({ activeDocumentPath }),
  setActiveHeading: (activeHeadingId) => set({ activeHeadingId })
}));
